import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
export const API = `${BACKEND_URL}/api/v1`;

export const fetchHome = () => axios.get(`${API}/home`).then(r => r.data);
export const fetchSettings = () => axios.get(`${API}/settings`).then(r => r.data);
export const fetchPage = (slug) => axios.get(`${API}/pages/${slug}`).then(r => r.data);
export const fetchBlogs = (params = {}) => axios.get(`${API}/blogs`, { params }).then(r => r.data);
export const fetchBlog = (slug) => axios.get(`${API}/blogs/${slug}`).then(r => r.data);

export const fetchProducts = (params = {}) => axios.get(`${API}/products`, { params }).then(r => r.data);
export const fetchProduct = (slug) => axios.get(`${API}/products/${slug}`).then(r => r.data);
export const fetchCategories = () => axios.get(`${API}/categories`).then(r => r.data);
export const fetchCategory = (slug) => axios.get(`${API}/categories/${slug}`).then(r => r.data);
export const fetchSpecialties = () => axios.get(`${API}/specialties`).then(r => r.data);
export const fetchFaqs = () => axios.get(`${API}/faqs`).then(r => r.data);
export const fetchDownloads = () => axios.get(`${API}/downloads`).then(r => r.data);

export const submitQuote = (data) => axios.post(`${API}/quotes`, data).then((r) => r.data);
export const submitContact = (data) => axios.post(`${API}/contact`, data).then((r) => r.data);
export const subscribeNewsletter = (email) =>
  axios.post(`${API}/newsletter`, { email }).then((r) => r.data);
